import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA } from 'src/app/constantes/permissao.constants';
import { PermissaoService } from 'src/app/shared/permissao.service';

@Component({
    selector: 'app-administracao-fgi',
    templateUrl: './administracao-fgi.component.html',
    standalone: false
})
export class AdministracaoFgiComponent implements OnInit {

    agenteFinanceiro$ = this.permissaoService.getPermissoesUsuarioAutenticado().pipe(
        map(permissoes => !!permissoes[ROLE_AGENTE_CONSULTA])
    );

    constructor(private permissaoService: PermissaoService) { }

    ngOnInit() {
    }

    fgiPRD() {
        location.href = "https://web.bndes.gov.br/FGI";
    }

    fgiHOM() {
        location.href = "https://web-h.bndes.gov.br/FGI";
    }

}
